import { Container, NotFoundError } from '@eigtech/ui-shared-dave'
import { createRootRoute } from '@tanstack/react-router'
import { AppContainer, App as BaseApp, PreAuthProviders } from '../components/Core/App'

export const Route = createRootRoute({
  component: () => (
    <PreAuthProviders>
      {/* <Outlet /> located in apps/cinnamon/ui-delegate/src/components/Core/App/App.tsx */}
      <BaseApp />
    </PreAuthProviders>
  ),
  notFoundComponent: () => (
    <AppContainer>
      <Container maxW="container.text">
        <NotFoundError />
      </Container>
    </AppContainer>
  ),
})
